export default "__VITE_ASSET__Cxb_I9YV__"